export const getHrPlaceName = (input) => {
    if (!input) return "";

    const suffixes = [
        "(Kommune)", "(Kommun)", "(Fylke)", "(Län)", "(Land)"
    ];

    function stripSuffix(part) {
        for (const suffix of suffixes) {
            if (part.endsWith(suffix)) {
                return part.slice(0, -suffix.length).trim();
            }
        }
        return part.trim();
    }

    const parts = input.split(" < ");
    const stripped = parts.map(stripSuffix);

    // If the last part (after stripping) is a duplicate of any previous, remove it
    if (
        stripped.length > 1 &&
        stripped.slice(0, -1).toString().indexOf(stripped[stripped.length - 1]) === 0
    ) {
        parts.pop();
        stripped.pop();
    }

    // Always return the stripped version
    return stripped.join(" < ");
}
